import React, { ReactNode, useState } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from 'src/shared/helpers/utils';

export type TooltipProps = {
    content: NonNullable<ReactNode>;
    children: ReactNode;
    isOpen?: boolean;
    placement?: 'top' | 'right' | 'bottom' | 'left';
    maxWidth?: number | string;
    padding?: number | string;
    sideOffset?: number;
    zIndex?: number;
};

const Tooltip = (props: TooltipProps) => {
    const { placement = 'right', children, content } = props;
    const [open, setOpen] = useState(false);
    const handleTooltipClose = () => {
        setOpen(false);
    };
    const handleTooltipOpen = () => {
        setOpen(true);
    };

    // Map placement to radix side
    const side: TooltipPrimitive.TooltipContentProps['side'] = placement;

    return (
        <TooltipPrimitive.Provider delayDuration={500} skipDelayDuration={500} disableHoverableContent>
            <TooltipPrimitive.Root open={open || !!props.isOpen} onOpenChange={setOpen}>
                <TooltipPrimitive.Trigger asChild>
                    <span onMouseEnter={handleTooltipOpen} onMouseLeave={handleTooltipClose} style={{ display: 'inline-flex' }}>
                        {children}
                    </span>
                </TooltipPrimitive.Trigger>
                <TooltipPrimitive.Portal>
                    <TooltipPrimitive.Content
                        side={side}
                        sideOffset={typeof props.sideOffset === 'number' ? props.sideOffset : 6}
                        className={cn(
                            'z-50 rounded-lg bg-white px-5 py-4 text-sm text-foreground shadow-xl data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0',
                            typeof props.maxWidth !== 'undefined' ? '' : 'max-w-[300px]'
                        )}
                        style={{ maxWidth: props.maxWidth, padding: props.padding, zIndex: props.zIndex }}
                    >
                        {content}
                        <TooltipPrimitive.Arrow className='fill-white drop-shadow-[0_1px_1px_rgba(0,0,0,0.08)]' />
                    </TooltipPrimitive.Content>
                </TooltipPrimitive.Portal>
            </TooltipPrimitive.Root>
        </TooltipPrimitive.Provider>
    );
};

export default Tooltip;
